export const stripTrailingDotZero = (v) => v?.replace(/\.0$/, "");
